// logo
export const LOGO_URL_WHITE = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/homepage-logo-white.png';
export const LOGO_URL_BLACK = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/homepage-logo-black.png';
// 安卓-二维码
export const QR_CODE_ANDROID_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/download-img-android.png';
// ios-二维码
export const QR_CODE_IOS_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/download-img-iOS.png';
// 空-二维码
export const QR_CODE_EMPTY_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/empty.png';
// 安卓-下载短链
export const DOWNLOAD_ANDROID_URL = 'https://downpack.baidu.com/xinxiang_AndroidPhone_1053723j.apk';
// ios-下载短链
export const DOWNLOAD_IOS_URL = 'https://apps.apple.com/cn/app/id6743755526';
// 下载icon
export const DOWNLOAD_ICON_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/download-icon.svg';
// 视频封面
export const POSTER_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/video-poster.png';
// 视频地址
export const VIDEO_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/video/video.mp4';
// pc-首屏背景图
export const PC_BG_DARK = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/pc-bg-dark.png';
export const PC_BG_LIGHT = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/pc-bg-light.png';
// wise-首屏背景图
export const WISE_BG_DARK = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/wise-bg-dark.png';
export const WISE_BG_LIGHT = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/wise-bg-light.png';

// 产品背景图
export const PRODUCT_BG_1= 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/section-part-1.png';
export const PRODUCT_BG_2 = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/section-part-2.png';
export const PRODUCT_BG_3 = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/section-part-3.png';
export const PRODUCT_BG_4 = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/section-part-4.png';

// 备案号
export const ICP_CONF = {
    network_security_code: '11000002000001',
    icp_code: '030173',
};

// 设计稿宽度
export const DESIGN_WIDTH = 1792;
export const DESIGN_HEIGHT = 1060;

// 标题
export const PAGE_TITLE_1 = '通用超级智能体';
export const PAGE_TITLE_2 = '超给力的AI指挥官';
// 副标题
export const PAGE_SUBTITLE = '多智能体协作、自主任务规划、多形态交付结果，用户仅需一句话即可一键完成复杂任务';
export const SLOGAN = '“把难题交给心响，把时间留给生活”';

// 浏览器视频兼容性提示
export const BROWSER_MESSAGES = {
    PLYR_UNSUPPORTED: 'Plyr 不支持当前浏览器，已回退到原生 HTML5 视频。',
    VERSION_LOW: '当前浏览器版本过低，已使用图片兜底。',
};

// 引导打开浏览器标识
export const GUIDE_URL = 'https://now.bdstatic.com/stash/v1/a395750/agent-scene-web/4405ea6/image/guide-marker.png';
